export enum PurchasesTypeEnum {
	Plan = 'plan',
	Notice = 'notice',
}
